import styled from 'styled-components';
import { Text } from '@ardoq/typography';
import { s8 } from '@ardoq/design-tokens';

const HelpTextContainer = styled.div`
  margin-top: ${s8};
`;

type HelpTextProps = {
  children: string;
};

export const HelpText = ({ children }: HelpTextProps) => (
  <HelpTextContainer>
    <Text variant="caption">{children}</Text>
  </HelpTextContainer>
);
